import styled from 'styled-components';

export const DatePickerLayout = styled.div`
    align-items: center;
    padding: 6px 0;

    &.inline {
        display: flex;
        justify-content: space-between;
    }

    &.without-label {
        flex: 1 1 auto;
    }

    owc-datepicker.space-for-error {
        > owc-input {
            margin-bottom: 20px !important;
        }
    }

    owc-typography.label {
        color: #706b69;

        &.block {
            padding-bottom: 8px;
        }
    }

    div[slot='calendar-footer'] {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;

        > div {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
        }

        .footer-info {
            margin-top: 0.5rem;
            text-wrap: wrap;

            > owc-typography {
                padding-left: 8px;
            }
        }
    }

    /* OWC-OVERRIDE: collapse the gap under the date field unless the .space-for-error rule
       above asks for it. owc-input reserves the space through its own --margin-bottom custom
       property, which is an undocumented internal in v7.6.0; !important on the plain
       declaration is the stable way to reset it. */
    owc-input.owc-input {
        margin-bottom: 0 !important;
    }
`;
